import { useNavigate, useParams } from 'react-router-dom';
import { Container, Card } from 'ui';
import { useSnack, useError } from 'hooks';
import { useTranslation } from 'react-i18next';
import { Header } from 'components';
import SettingRequestForm from 'components/Forms/SettingRequestForm';
import { createSettingRequest } from 'api/node/settingRequests';

const CreateSettingRequest = ({ kind }) => {
  const { t } = useTranslation('settingRequest');
  const navigate = useNavigate();
  const { notify } = useSnack();
  const { sendErrorSnack } = useError();
  const { settingName } = useParams();

  const handleCreateSettingRequest = async (values) => {
    try {
      const input = {
        ...values,
        settingName,
        kind,
      };

      const data = await createSettingRequest({ payload: input });

      if (data?.errors?.length > 0) {
        throw data?.errors?.[0];
      }

      navigate(-1);
      notify(t('createSettingRequestSuccess'));
    } catch (err) {
      sendErrorSnack(err);
    }
  };

  return (
    <>
      <Header />

      <Container size="narrow">
        <Card>
          <SettingRequestForm onSubmit={handleCreateSettingRequest} />
        </Card>
      </Container>
    </>
  );
};

export default CreateSettingRequest;
